import { Grid, Paper } from '@material-ui/core';
import React, { memo } from 'react';
import CheckboxRhf from '../CheckboxRhf/CheckboxRhf';
import { useFormContext } from 'react-hook-form';
import { useLang } from '../../../util/lang';

const data = [
    {
        name: 'SD1',
        label: 'SD1',
        centrals: '@PatientInfo.smileDesign.prescriptionNotes.option.squareRound',
        laterals: '@PatientInfo.smileDesign.prescriptionNotes.option.squareRound',
        cuspids: '@PatientInfo.smileDesign.prescriptionNotes.option.pointed',
    },
    {
        name: 'SD2',
        label: 'SD2',
        centrals: '@PatientInfo.smileDesign.prescriptionNotes.option.squareRound',
        laterals: '@PatientInfo.smileDesign.prescriptionNotes.option.squareRound',
        cuspids: '@PatientInfo.smileDesign.prescriptionNotes.option.flat',
    },
    {
        name: 'SD3',
        label: 'SD3',
        centrals: '@PatientInfo.smileDesign.prescriptionNotes.option.squareRound',
        laterals: '@PatientInfo.smileDesign.prescriptionNotes.option.shortSquareRound',
        cuspids: '@PatientInfo.smileDesign.prescriptionNotes.option.round',
    },
    {
        name: 'SD4',
        label: 'SD4',
        centrals: '@PatientInfo.smileDesign.prescriptionNotes.option.squareRound',
        laterals: '@PatientInfo.smileDesign.prescriptionNotes.option.squareRound',
        cuspids: '@PatientInfo.smileDesign.prescriptionNotes.option.round',
    },
    {
        name: 'SD5',
        label: 'SD5',
        centrals: '@PatientInfo.smileDesign.prescriptionNotes.option.roundRound',
        laterals: '@PatientInfo.smileDesign.prescriptionNotes.option.shortRound',
        cuspids: '@PatientInfo.smileDesign.prescriptionNotes.option.Round',
    },
    {
        name: 'SD6',
        label: 'SD6',
        centrals: '@PatientInfo.smileDesign.prescriptionNotes.option.squareSquare',
        laterals: '@PatientInfo.smileDesign.prescriptionNotes.option.shortSquare',
        cuspids: '@PatientInfo.smileDesign.prescriptionNotes.option.pointed',
    },
    { name: 'SD7', label: 'SD7', text: '@PatientInfo.smileDesign.prescriptionNotes.option.verticalDimension'},
];

const opacity = (readOnly, disable, defaultValue, name) => {
    if (defaultValue) {
        if (readOnly && defaultValue.includes(name)) {
            return 1;
        } else {
            return 0.5;
        }
    } else {
        return disable ? 0.5 : 1;
    }
};

const SDTeethRhf = ({ name, disable = false, showSingleError, readOnly = false, defaultValue = undefined ,displayFirstFitFlag = false}) => {
    const get = useLang();
    const { watch, setValue } = useFormContext();
    const selectedValues = watch(name) || [];

    return (
        <Grid
            container
            style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(3, minmax(0, 430px))',
                gap: 16,
                justifyContent: 'start',
            }}
        >
            {data.filter((value) => value.name !== 'SD7').map((value, index) => (
                <Grid
                    key={`teeth-${index}`}
                    item
                    style={{
                        opacity: opacity(readOnly, disable, defaultValue, `SD${index + 1}`),
                        width: '100%',
                    }}
                >
                    <Paper
                        component="label"
                        elevation={3}
                        className="sd-image-option"
                        style={{
                            display: 'block',
                            width: 430,
                            maxWidth: '100%',
                            boxSizing: 'border-box',
                            padding: 12,
                            border: selectedValues.includes(value.name)
                                ? '2px solid rgba(26, 168, 184, 0.5)'
                                : '2px solid transparent',
                            boxShadow: selectedValues.includes(value.name)
                                ? '0 4px 12px rgba(26, 167, 184, 0.18)'
                                : undefined,
                            borderRadius: 8,
                            backgroundColor: '#f5f5f5',
                            cursor: 'pointer',
                            transition: 'border-color 200ms ease, box-shadow 200ms ease',
                        }}
                    >
                        <img
                            src={`/img/SDTeeth/SD${index + 1}.jpg`}
                            width={'100%'}
                            style={{
                                display: 'block',
                                height: 'auto',
                                aspectRatio: '16/5.5',
                                objectFit: 'cover',
                                borderRadius: 8,
                            }}
                            alt={`teeth-${value.name}`}
                        />
                        <div style={{ paddingTop: 8 }}>
                            <div style={{ paddingRight: 8 }}>
                                <CheckboxRhf
                                    label={<strong>{value.label}</strong>}
                                    name={name}
                                    defaultValue={[]}
                                    disable={disable}
                                    readOnly={readOnly}
                                    question={false}
                                    showSingleError={showSingleError}
                                    checkBoxValue={value.name}
                                    onChange={(event) =>
                                        setValue(name, event.target.checked ? [event.target.value] : [])
                                    }
                                />
                            </div>
                        </div>
                        <Grid container alignItems="center" style={{ paddingLeft: 8, paddingBottom: 8 }}>
                            {value?.centrals && (
                                <Grid item xs={12}>
                                    {get('@PatientInfo.smileDesign.prescriptionNotes.option.centrals')}:{' '}
                                    {get(value.centrals)}
                                </Grid>
                            )}
                            {value?.laterals && (
                                <Grid item xs={12}>
                                    {get('@PatientInfo.smileDesign.prescriptionNotes.option.laterals')}:{' '}
                                    {get(value.laterals)}
                                </Grid>
                            )}
                            {value?.cuspids && (
                                <Grid item xs={12}>
                                    {get('@PatientInfo.smileDesign.prescriptionNotes.option.cuspids')}:{' '}
                                    {get(value.cuspids)}
                                </Grid>
                            )}
                            {value?.text && (
                                <Grid item xs={12}>
                                    {get('@PatientInfo.smileDesign.prescriptionNotes.option.verticalDimension')}
                                </Grid>
                            )}
                        </Grid>
                    </Paper>
                </Grid>
            ))}
        </Grid>
    );
};

export default memo(SDTeethRhf);
